/**
 * Contrato estándar para formularios usados dentro de Modal v2.
 * Ver design_language_v2.md §10 y _template/README.md.
 */
import type { ReactNode } from "react";

export interface FormV2Props {
  /** Cierra el Modal v2 padre. Fallback temporal: closeDrawer() en forms legacy. */
  onClose?: () => void;
  /** Oculta título interno del form cuando el Modal v2 ya provee header. */
  hideHeader?: boolean;
  /**
   * Oculta ModalButtons en el body; el padre debe renderizar `footer` en el Modal.
   * Usar con `form` id + `submitButtonProps.form` o `onFooterChange`.
   */
  hideFooter?: boolean;
  /**
   * Publica acciones Cancelar/Guardar en el slot `footer` del Modal padre.
   * No renderizar ModalButtons dentro del body cuando se usa.
   */
  onFooterChange?: (footer: ReactNode) => void;
}

/** Resuelve onClose con fallback a closeDrawer legacy durante migración. */
export function resolveFormClose(
  onClose: (() => void) | undefined,
  closeDrawer: () => void
): () => void {
  return onClose ?? closeDrawer;
}
